import { Outlet } from 'react-router-dom';
import { StyledMain } from './styles';

export const Auth = () => (
  <StyledMain>
    <Outlet />
  </StyledMain>
);
